import { render, staticRenderFns } from "./Rangaistustaulukko.vue?vue&type=template&id=8dea22c6&scoped=true&"
import script from "./Rangaistustaulukko.vue?vue&type=script&lang=js&"
export * from "./Rangaistustaulukko.vue?vue&type=script&lang=js&"
import style0 from "./Rangaistustaulukko.vue?vue&type=style&index=0&id=8dea22c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea22c6",
  null
  
)

export default component.exports